import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment"
import { Preferences } from '../models/settings';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private httpClient: HttpClient) { }

  public getSettings() : any{
    return this.httpClient.get<any[]>(`${environment.settingsEndpoint}settings.json`);
  }

  public getRedirectURL(nibbles, domain) : any{
    return this.httpClient.get<any[]>(`${environment.tokenDecriptionEndpoint}nibbles=${nibbles}&domain=${domain}`);
  }

  public getPreferences(domain: string): Preferences {
    const { overrides, ...defaultPreferences } = environment.preferences;
    return {
      ...defaultPreferences,
      ...overrides[domain]
    };
  }
}
